// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-2Iv7_";
var _3 = "wrapper_fullScreen-1ZNjM";
var _4 = "loader-20Qkt";
var _5 = "rotation-3dadK";
export { _1 as "__esModule", _2 as "wrapper", _3 as "wrapper_fullScreen", _4 as "loader", _5 as "rotation" }
export default { "__esModule": _1, "wrapper": _2, "wrapper_fullScreen": _3, "loader": _4, "rotation": _5 }
